<!-- consultar-productos-comercializadores.component.html -->
<div class="container my-4">
    <!-- Encabezado -->
    <div
        class="d-flex justify-content-between align-items-center mb-4 border-bottom pb-2">
        <h3 class="fw-semibold text-success mb-0 --bs-success">
            <i class="bi bi-box-seam me-2"></i>
            Productos
        </h3>
        <span class="text-muted small">
            Gestión de presentaciones y estados
        </span>
    </div>

    <!-- Componente de paginación superior -->
    <app-paginacion-superior
        [paginaActual]="paginaActual"
        [totalPaginas]="totalPaginas"
        [totalRegistros]="totalRegistros"
        [limite]="limite"
        [textoRegistros]="'presentaciones'"
        (paginaAnterior)="paginaAnterior()"
        (paginaSiguiente)="paginaSiguiente()"
        (cambiarLimite)="cambiarLimite($event)"></app-paginacion-superior>

    <!-- Componente de tabla -->
    <app-tabla-productos
        [presentaciones]="presentaciones"
        [paginaActual]="paginaActual"
        [totalPaginas]="totalPaginas"
        (cambiarEstado)="cambiarEstado($event)"
        (paginaAnterior)="paginaAnterior()"
        (paginaSiguiente)="paginaSiguiente()"
        (filtrar)="onFiltroAplicado($event)">
        >
    </app-tabla-productos>
</div>
